// extracted by mini-css-extract-plugin
module.exports = {"status":"_2tbAQ59eEFcjvP4t3O5LPn"};